import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoEletronicos() {
  return (
    <ArtigoPlaceholder
      title="Como Comprar Eletrônicos da China com Segurança Usando CSSBuy Spreadsheet"
      desc="Guia completo para comprar smartphones, fones, acessórios e gadgets da China. Como verificar compatibilidade, voltagem e garantias antes de comprar."
      icon="ri-smartphone-line"
      slug="artigo-cssbuy-eletronicos"
    />
  );
}